<template>
  <div class="container">
    <div class="main">
      <p class="smallTitle development">開発者ポータル</p>
      <p class="explane">
        データカタログにて公開している一部のオープンデータを、APIを用いて取得することが可能です。<br />
        本ページではAPI機能の使い方やサンプルコードを掲載しています。
      </p>
    </div>
    <div class="contentsArea">
      <div class="contents">
        <div class="sidebar">
          <div
            class="sidebarItem"
            v-for="item in sidebarItems"
            :key="item.name"
          >
            <div
              class="sidebarBg"
              :class="[
                {
                  normal: item.name != selected,
                  hilight: item.name == selected,
                },
              ]"
            >
              <router-link :to="{ name: item.path }" @click="select(item.name)">
                {{ item.name }}
              </router-link>
            </div>
          </div>
        </div>
        <router-view class="context"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: "リリース",
      sidebarItems: [
        {
          name: "リリース",
          path: "developmentContentRelease",
        },
        {
          name: "API概要",
          path: "developmentContentAboutApi",
        },
        {
          name: "利用手順",
          path: "developmentContentHowToUse",
        },
        {
          name: "API仕様",
          path: "developmentContentRefarense",
        },
        {
          name: "提供データ",
          path: "developmentContentData",
        },
        {
          name: "サンプルコード",
          path: "developmentContentSampleCode",
        },
        {
          name: "クレジット表示",
          path: "developmentContentCredit",
        },
        {
          name: "API利用規約",
          path: "developmentApiTerms",
        },
      ],
    };
  },
  methods: {
    select(name) {
      this.selected = name;
    },
  },
  mounted(){
    let path = this.$route.path.split('/')[2]
    switch (path) {
      case 'release':
        this.selected = "リリース"
        break
      case 'about-api':
        this.selected = "API概要"
        break
      case 'howtouse':
        this.selected = "利用手順"
        break
      case 'refarense':
        this.selected = "API仕様"
        break
      case 'data':
        this.selected = "提供データ"
        break
      case 'sample-code':
        this.selected = "サンプルコード"
        break
      case 'credit':
        this.selected = "クレジット表示"
        break
      case 'api-terms':
        this.selected = "API利用規約"
        break
    }
  }
}
</script>

<style scoped>
.container {
  width: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.main {
  width: 80%;
  margin-top: 100px;
}

.smallTitle {
  font-size: 2.5vw;
  font-weight: 800;
  color: #072a40;
  position: relative;
  margin-bottom: 70px;
}

.smallTitle.development::after {
  content: "DEVELOPER PORTAL";
  font-size: 60%;
  color: #d9b97e;
  position: absolute;
  top: 100%;
  left: 0;
}

.explane {
  font-size: 1.5vw;
}

.contentsArea {
  margin: 100px 0;
  padding: 48px 0;
  width: 100%;
  background-color: #f2f2f2;
  display: flex;
  justify-content: center;
}

.contents {
  width: 80%;
  background-color: white;
  display: grid;
  grid-template-columns: 16vw auto;
  grid-template-rows: 1fr;
  padding: 2%;
  column-gap: 4%;
}

.sidebar {
  display: flex;
  flex-direction: column;
}

.sidebarItem {
  font-size: 1.5vw;
  font-weight: 700;
  padding: 4%;
}

.sidebarBg {
  padding: 4% 10%;
  width: fit-content;
  height: fit-content;
}

a:link,
a:link,
a:visited,
a:hover,
a:active {
  color: black;
  text-decoration: none;
}

.hilight {
  background-color: #85bff2;
  border-radius: 100px;
}

.context {
  padding: 1%;
}
</style>
